import React, { useState, useEffect, useContext } from 'react'
import * as classes from './Preloader.module.scss'
import IconLogoMini from './IconLogoMini'
import anime from 'animejs'
import { FormContext } from '../../../context'

function Preloader() {
    const { setAnimationStart, setIsVisibilityPreloader } = useContext(FormContext)
    const [count, setCount] = useState(0)

    useEffect(() => {
        const timeout = setTimeout(() => {
            setCount((prev) => prev + 1)
        }, 25)

        if (count >= 100) {
            clearTimeout(timeout)

            setTimeout(() => {
                setAnimationStart(true)

                const wrap = document.querySelector(`.${classes.Wrap}`)

                if (wrap) {
                    anime({
                        targets: wrap,
                        duration: 750,
                        delay: 0,
                        easing: 'cubicBezier(.25, .1, .25, 1)',
                        opacity: [1, 0]
                    }).finished.then(() => setIsVisibilityPreloader(false))
                } else {
                    setIsVisibilityPreloader(false)
                }
            }, 200)
        }

        return () => clearTimeout(timeout)
    }, [count])

    return (
        <div className={classes.Preloader}>
            <div className={classes.Wrap}>
                <div className={classes.Logo}>
                    <IconLogoMini />
                </div>
            </div>
        </div>
    )
}

export default Preloader
